function buildChildAttributes(params) {
  const { node, filterTagName } = params;
  if (!node) return [];
  const children = node && "children" in node ? node.children : [];
  const attrsOfChildren = children.filter((child) => {
    if (child.type !== "element") return false;
    return filterTagName ? child.tagName === filterTagName : true;
  }).map((child) => {
    return child.properties?.dataAttrs ? safeJSONParse(child.properties?.dataAttrs) : null;
  }).filter((attr) => attr !== null);
  return attrsOfChildren;
}
function safeJSONParse(value) {
  try {
    return JSON.parse(value || "{}");
  } catch {
    console.error("Failed to parse JSON:", value);
    return {};
  }
}
export {
  buildChildAttributes
};
//# sourceMappingURL=build-child-attributes.js.map
